import PropTypes from 'prop-types'
import classNames from 'classnames'
import React, { Component } from 'react'
import Dropdown from 'mobile/views/application/chrome/dropdown'
import { X } from '@everlane/icon'

class TrayTwo extends Component {
  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    onRequestClose: PropTypes.func,
    shouldDropDown: PropTypes.bool,
    showHeader: PropTypes.bool,
    className: PropTypes.string,
    showCloseButton: PropTypes.bool,
    scrollable: PropTypes.bool,
  }

  static defaultProps = {
    shouldDropDown: true,
    showHeader: true,
    className: '',
    showCloseButton: true,
    scrollable: false,
  }

  disableScroll = e => {
    e.preventDefault()
    e.stopImmediatePropagation()
  }

  componentDidMount() {
    // prevent document body scroll
    document.body.classList.add('modal-open')
    const reactPortalEl = document.getElementById('react-portal')
    if (reactPortalEl) {
      reactPortalEl.addEventListener('touchmove', this.disableScroll)
      reactPortalEl.classList.add('tray__scrim--two')
      // TODO: replace with reactDOM.createPortal after upgrading to react v16.0
      document.getElementById('react-portal')
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('modal-open')
    const reactPortalEl = document.getElementById('react-portal')
    if (reactPortalEl) {
      reactPortalEl.removeEventListener('touchmove', this.disableScroll)
      reactPortalEl.classList.remove('tray__scrim--two')
      // TODO: replace with reactDOM.createPortal after upgrading to react v16.0
      document.getElementById('react-portal')
    }
  }

  render() {
    const header = (() => {
      if (this.props.title) {
        return (
          <div className="tray__header">
            <span className="tray__title">{this.props.title}</span>
            {this.props.showCloseButton && (
              <X className="tray__close-button" onClick={this.props.onRequestClose} />
            )}
          </div>
        )
      } else if (this.props.onRequestClose) {
        return (
          <div className="tray__header tray__header-no-border">
            {this.props.showCloseButton && (
              <X className="tray__close-button" onClick={this.props.onRequestClose} />
            )}
          </div>
        )
      } else {
        return null
      }
    })()

    return (
      <div className={classNames('tray__wrapper', this.props.className)}>
        <Dropdown
          appear={this.props.shouldDropDown}
          fullScreen={true}
          showCloseButton={false}
          scrollable={this.props.scrollable}
        >
          {this.props.children && (
            <div className={this.props.className}>
              {this.props.showHeader && header}
              <div className="tray__content">{this.props.children}</div>
            </div>
          )}
        </Dropdown>
      </div>
    )
  }
}

export default TrayTwo
